import {Button as ButtonMUI} from '@mui/material';

const Button = (props) => {

    const {
                sx, variant = 'contained', disabled,
                onClick, 
                href, to, component, target,
                children
        } 
    = props

    return <ButtonMUI 
                        sx={{
                            bgcolor: '#1777b7',
                            color: 'white',
                            '&:hover': {
                            bgcolor: 'rgba(23, 119, 183, 0.8)', // Couleur légèrement plus claire pour l'état de survol
                            },
                            '&:active': {
                            bgcolor: 'rgba(23, 119, 183, 1)', // Couleur un peu plus foncée pour l'état pressé
                            },
                            '&:focus': {
                            boxShadow: '0 0 0 2px rgba(255,255,255,0.75)', // Ombre extérieure pour l'état focus
                            },
                            ...sx,
                        }}

                        variant={variant}
                        disabled={disabled}

                        onClick={onClick}

                        href={href}
                        to={to}
                        component={component}
                        target={target}

                        
                        
                        
            >
        {children}
    </ButtonMUI>
}

export default Button